import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMaxHeel = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 73.551,
	height: 34.802,
	viewBox: "0 0 73.551 34.802",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_198",
		"data-name": "Group 198",
		transform: "translate(0.5 0.5)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_51",
				"data-name": "Rectangle 51",
				width: 72.551,
				height: 33.802,
				fill: "none",
				stroke: "#040505",
				strokeWidth: 1,
				opacity: 0
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_197",
				"data-name": "Group 197",
				transform: "translate(20.463 0.511)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_395",
						"data-name": "Path 395",
						d: "M1368.52,485.918c-.269-.286-.582-.609-.917-.954a22.989,22.989,0,0,1-3.463-4.089c-.645-1.492-1.913-5.819-2.427-7.611a1.253,1.253,0,0,0-.407-.616c.141-.2.3-.416.482-.638.842-1,2.568-3.019,3.53-4.141a1.056,1.056,0,0,0-.114-1.488h0a1.056,1.056,0,0,0-1.49.114c-.965,1.127-2.7,3.152-3.543,4.158a9.478,9.478,0,0,0-1.627,2.693l-.107.052a3.334,3.334,0,0,1-1.684-1.093,4.318,4.318,0,0,1-.628-1.651c-.009-.046-.029-.088-.039-.133.3-.246.658-.567,1.135-.991a30.515,30.515,0,0,0,4.019-5.394,1.055,1.055,0,1,0-1.811-1.084,28.037,28.037,0,0,1-3.609,4.9c-.619.549-.985.859-1.2,1.032a2.129,2.129,0,0,0-1.355.043,10.482,10.482,0,0,0-1.776.886,19.1,19.1,0,0,0-2.928,2.181,6.272,6.272,0,0,0-2.152.986,1.057,1.057,0,0,0-.525.838,6.571,6.571,0,0,0,2.239,4.809c2.087,2.1,9.478,8.175,9.828,8.461.165.124,4.07,3.025,7.314,3.075h.105c1.756,0,3.1-.681,3.608-1.833A2.277,2.277,0,0,0,1368.52,485.918Zm-13.474-16.858a1.029,1.029,0,0,1,.193.049A1.028,1.028,0,0,0,1355.046,469.06Zm-.037,0a.982.982,0,0,0-.147-.009l.019,0A1.1,1.1,0,0,1,1355.008,469.056Zm12.041,18.52c-.106.24-.655.6-1.75.574-2.122-.033-5.109-1.925-6.043-2.623-.076-.062-7.62-6.262-9.633-8.289a5.466,5.466,0,0,1-1.57-2.658c.32-.172.6-.315.756-.377l.158,0a1.063,1.063,0,0,0,.778-.324,15.838,15.838,0,0,1,2.848-2.17,7.369,7.369,0,0,1,1.437-.7c.013.008.014.014.015.017a6.254,6.254,0,0,0,.972,2.481,5.77,5.77,0,0,0,3.572,2.1,1.056,1.056,0,0,0,.891-.274c.158-.149.336-.3.506-.438.675,2.31,1.64,5.488,2.216,6.819.518,1.2,2,2.777,3.885,4.72.327.337.633.653.9.932C1367.091,487.48,1367.064,487.54,1367.049,487.577Z",
						transform: "translate(-1342.532 -462.537)",
						fill: "#040505"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_396",
						"data-name": "Path 396",
						d: "M1393.675,519.745h-3.111a1.1,1.1,0,0,0-1.1.878,1.057,1.057,0,0,0,1.042,1.233h3.111a1.094,1.094,0,0,0,1.1-.878A1.056,1.056,0,0,0,1393.675,519.745Z",
						transform: "translate(-1363.106 -489.549)",
						fill: "#040505"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_397",
						"data-name": "Path 397",
						d: "M1368.958,519.745h-7.67a1.1,1.1,0,0,0-1.1.878,1.056,1.056,0,0,0,1.041,1.233h7.67a1.1,1.1,0,0,0,1.1-.878A1.057,1.057,0,0,0,1368.958,519.745Z",
						transform: "translate(-1349.282 -489.549)",
						fill: "#040505"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_398",
						"data-name": "Path 398",
						d: "M1343.76,519.745h-3.11a1.1,1.1,0,0,0-1.1.878,1.056,1.056,0,0,0,1.041,1.233h3.11a1.1,1.1,0,0,0,1.1-.878A1.057,1.057,0,0,0,1343.76,519.745Z",
						transform: "translate(-1339.537 -489.549)",
						fill: "#040505"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_399",
				"data-name": "Path 399",
				d: "M1341.734,499.839l-1.01,1.01v-8.467l1.01,1.01a1.056,1.056,0,1,0,1.493-1.493l-2.811-2.81a1.035,1.035,0,0,0-.162-.132.867.867,0,0,0-.078-.043,1.126,1.126,0,0,0-.1-.054,1.074,1.074,0,0,0-.105-.033c-.03-.009-.06-.021-.091-.027a1.053,1.053,0,0,0-.414,0c-.031.006-.061.018-.091.027a1.058,1.058,0,0,0-.106.033c-.036.015-.069.036-.1.054a.863.863,0,0,0-.078.043,1.058,1.058,0,0,0-.162.132l-2.811,2.81a1.056,1.056,0,1,0,1.493,1.493l1.01-1.01v8.467l-1.01-1.01a1.056,1.056,0,0,0-1.493,1.493l2.812,2.811a1.056,1.056,0,0,0,1.493,0l2.812-2.811a1.056,1.056,0,0,0-1.493-1.493Z",
				transform: "translate(-1317.311 -474.416)",
				fill: "#040505"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgMaxHeel);
export { ForwardRef as ReactComponent };
